import { createCrud } from '@lumahealthhq/ui-model';
var basePath = 'followupWorkflowInstances';
var crud = createCrud(basePath);

/* Default queries */
export var useFollowupWorkflowInstanceCount = crud.makeCount();
export var useFollowupWorkflowInstanceById = crud.makeFindById();
export var useFollowupWorkflowInstanceByIds = crud.makeFindByIds();
export var useFollowupWorkflowInstanceMany = crud.makeFindMany();
export var useFollowupWorkflowInstanceOne = crud.makeFindOne();
export var useFollowupWorkflowInstancePagination = crud.makePagination();

/* Default mutations */
export var useFollowupWorkflowInstanceCreateOne = crud.makeCreateOne();
export var useFollowupWorkflowInstanceUpdateOne = crud.makeUpdateOne();
export var useFollowupWorkflowInstanceRemoveById = crud.makeRemoveById();